<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer">应用详情</p>
    <div class="formStyle">
      <Form :model="formItem" :label-width="100" style="padding:20px">
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">应用Logo</Col>
            <Col span="15">
              <img :src="formItem.appLogo" style="width: 100px; height: 100px">
            </Col>
          </Row>
        </formItem>
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品名称</Col>
            <Col span="15">
              <Input v-model="formItem.productTitle" readonly></Input>
            </Col>
          </Row>
        </formItem><!--产品名称-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">包名</Col>
            <Col span="15">
              <Input readonly v-model="formItem.packageName"></Input>
            </Col>
          </Row>
        </formItem>
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">Appid</Col>
            <Col span="15">
              <Input v-model="formItem.appid" readonly></Input>
            </Col>
          </Row>
        </formItem><!--产品appid-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品id</Col>
            <Col span="15">
              <Input v-model="formItem.productId" readonly></Input>
            </Col>
          </Row>
        </formItem><!--产品id-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">应用版本</Col>
            <Col span="15">
              <Input readonly v-model="formItem.appVersion"></Input>
            </Col>
          </Row>
        </formItem><!--产品版本-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">上架时间</Col>
            <Col span="15">
              <Input readonly v-model="formItem.time"></Input>
            </Col>
          </Row>
        </formItem><!--产品版本-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">应用类别</Col>
            <Col span="15">
              <RadioGroup v-model="formItem.appCategory">
                <Radio label="1" disabled>启明应用</Radio>
                <Radio label="2" disabled>启明游戏</Radio>
                <Radio label="3" disabled>其他应用</Radio>
                <Radio label="4" disabled>其他游戏</Radio>
                <Radio label="5" disabled>未分类</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </formItem>
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品简介</Col>
            <Col span="15">
              <Input readonly type="textarea"
                     v-model="formItem.productShortDescribe"></Input>
            </Col>
          </Row>
        </formItem><!--产品简介-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品详情</Col>
            <Col span="15">
              <Input readonly type="textarea"
                     :autosize="{minRows: 4,maxRows: 8}"
                     v-model="formItem.productDescribe"></Input>
            </Col>
          </Row>
        </formItem>
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">展示视频</Col>
            <Col span="15">
              <video controls="controls" style="max-height: 300px" :src="formItem.playerSrc"></video>
            </Col>
          </Row>
        </formItem><!--视频上传-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">展示图片</Col>
            <Col span="15" class="formItemShow">
              <div v-for="item in imgList" class="showImg">
                <img :src="item" style="width: 200px; height: 300px">
              </div>
            </Col>
          </Row>
        </formItem><!--图片上传-->
        <formItem style="text-align: center">
          <Button type="primary" @click="editAppDetail(formItem.areaId, sortOrder)">更新版本</Button>
        </formItem>
      </Form>
    </div>

  </div>
</template>

<script>
    import {adminRouter} from "../../router/admin";
    import {format2Sec} from "../../utils/format";

    export default {
        name: "webAppDetail",
        data(){
            return{
                pageInfo: {},
                formItem:{},
                playerOptions: {},
                sortOrder: 0,
                imgList: [],
            };
        },
        methods:{
            apkUploadSuccess(res, file){
                this.apkPath.push({name:file.name, path:res.content});
            },
            videoUploadSuccess(res, file){
                this.videoPath.push({name:file.name, path:res.content});
            }, //视频上传
            imgUploadSuccess(res, file){
                this.imgPath.push({name:file.name, path:res.content});
            }, //图片上传
            editAppDetail(areaId, order){
                let active = 'editWebAppDetail';
                let currentTag = localStorage.getItem('currentTag');
                if (currentTag !== active){
                    let tags = null;
                    for (let ele of adminRouter){
                        if (ele.name === active){
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length){
                                for (let val of ele.children){
                                    if (val.name === active){
                                        tags = {
                                            title: val.title,
                                            name: val.name,
                                            path: val.path
                                        };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    localStorage.setItem("currentTag", active);
                    localStorage.setItem("areaId", areaId);
                    localStorage.setItem("sortOrder", order);
                    this.$store.commit("updateCurrentTag", active);
                    this.$store.commit("updateOpenedTags", [tags]);
                    this.$store.commit("updateCurrentPath", active);
                    this.$router.push({
                        name: active
                    });
                }
            }
        },

        watch: {
        },
        created() {
        },

        activated() {
            this.formItem = {};
            let area = 'productInfoArea' + localStorage.getItem('areaId');
            let order = Number(localStorage.getItem('sortOrder'));
            this.sortOrder = order;
            this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(
                res => {
                    let tempData = res.data.content;
                    this.formItem = tempData[area][order];
                    if (this.formItem.createDate){
                        this.formItem.time = format2Sec(this.formItem.createDate);
                    }
                    this.imgList = this.formItem.posterSrc.split('分割');
                    this.formItem.appCategory = String(this.formItem.appCategory);
                }
            );
        }
    };
</script>

<style scoped>
  .container {
    padding: 0;
    margin: 20px 0 0 25px;
  }  /*全局配置*/
  .formStyle{
    background-color: #fff;
    margin:2% auto;
    width: 96%;
    border-radius: 5px;
  }  /*表单外观设置*/
  .formTitle{
    font-size: 20px;
    font-family: "黑体";
    padding:15px;
    text-align: center;
  }  /*表单标题*/
  .formItemTitle{
    font-size: 18px;
  }  /*表单项目标题*/
  .formItemShow{
    display: flex;
    justify-content: flex-start;
  }

  .showImg{
    padding-right: 20px;
  }

</style>



// WEBPACK FOOTER //
// webAppDetail.vue?c1f487ba